import { api } from '@/lib/api/client'
import { toSession, type AuthSession } from '@/features/auth/api/auth'
import type { AuthResponse } from '@/features/auth/types/auth'
import type { SsoRedirectResponse } from '@/features/sso/types/sso'

/** Asks the backend for the URL that signs the current user in on the peer system. */
export async function requestSsoRedirect(): Promise<string> {
  const { data } = await api.post<{ data: SsoRedirectResponse }>('/sso/redirect')

  return data.data.redirect_url
}

/** Trades a one-time code from the peer for a native session. */
export async function exchangeSsoCode(code: string): Promise<AuthSession> {
  const { data } = await api.post<{ data: AuthResponse }>('/sso/exchange', { code })

  return toSession(data.data)
}
